import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffCrudReport = () => import('./staff/crudReport')
const ViewStaffDetailReport = () => import('./staff/detailReport')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'ReportsServicesStaffDashboard',
  crudReport: 'ReportsServicesStaffCrudReport',
  detailReport: 'ReportsServicesStaffDetailReport',
}

const router =
  [
    {
      path: '/st/reports-services',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Reporte de servicios',
          }                  
        },        
        {
          path: 'crud',
          name: VIEWS.crudReport,
          component: ViewStaffCrudReport,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Gestión de reporte de servicios',
          }                            
        },  
        {
          path: 'crud/customers/:customersID',
          name: 'ReportsServicesStaffCrudReportByCustomers',
          component: ViewStaffCrudReport,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Gestión de reporte de servicios desde cliente',
          }                            
        },                
        {
          path: 'detail/:reportID/view',
          name: VIEWS.detailReport,
          component: ViewStaffDetailReport,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Detalle de reporte de servicios',
          }                            
        },
      ]
    },

    {
      path: '/cu/reports-services',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/reports-services',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
export { VIEWS }
